export default __webpack_public_path__ + "assets/img/LVM_GEO_logo_128.jpg";